import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

export type CambiarVendedorInputs = "idVendedor" | "razonCambioVendedor";
export type CambiarVendedorButtons = "aceptar" | "cancelar";

export const cambiarVendedorFormConfig: FormBuilderConfig<
  CambiarVendedorInputs,
  CambiarVendedorButtons
> = {
  inputs: [
    {
      name: "idVendedor",
      label: "Vendedor",
      bts: { mCol: 12 },
      component: IUserSelectorBuilder
    },
    {
      name: "razonCambioVendedor",
      label: "Razón del Cambio",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        maxlength: 500
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idVendedor: {
      required: true
    },
    razonCambioVendedor: {
      required: true,
      minLength: 1
    }
  },
  rows: [["idVendedor"], ["razonCambioVendedor"], ["aceptar", "cancelar"]]
};
